var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash-03"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M33 11H55M11 22H77M69.6667 22L67.0953 60.5707C66.7095 66.3576 66.5166 69.2511 65.2667 71.445C64.1663 73.3766 62.5066 74.9294 60.5061 75.8988C58.2339 77 55.334 77 49.5343 77H38.4657C32.666 77 29.7661 77 27.4939 75.8988C25.4934 74.9294 23.8337 73.3766 22.7333 71.445C21.4834 69.2511 21.2905 66.3576 20.9047 60.5707L18.3333 22M36.6667 38.5V56.8333M51.3333 38.5V56.8333",
    stroke: "white",
    strokeWidth: 2.44444,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash03);
export default __webpack_public_path__ + "static/media/trash-03.2eeba0159f05db1527d9e22698d6722b.svg";
export { ForwardRef as ReactComponent };